import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.harvest_weighing_form', () => {
  import('./internal/form').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.harvest_weighings_map', () => {
  import('./internal/map').then(({ default: Component }) => Component());
});
